var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoppingcart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.461 10.5h4.503l6.187 18.484a1.5 1.5 0 0 0 1.423 1.023h15.845a1.5 1.5 0 0 0 1.423-1.025L39 16.5h0-19.5",
    stroke: "#212121",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#212121",
    strokeWidth: 3,
    fill: "#FFF",
    cx: 19.5,
    cy: 37.5,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#212121",
    strokeWidth: 3,
    fill: "#FFF",
    cx: 31.5,
    cy: 37.5,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#212121",
    strokeWidth: 3,
    strokeLinecap: "round",
    d: "M21 22.5h15"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingcart);
export default __webpack_public_path__ + "static/media/Shoppingcart.07e2a889069ecc6021df9e311a307b8f.svg";
export { ForwardRef as ReactComponent };